import {
  Box,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../../resources/strings/StringKeys';
import COLORS from '../../../../../resources/style/Themes';
import { EmergencyContactInfoOnAzure } from '../../../../../../generated-client/models';

interface ResponseTeamListProps {
  users: EmergencyContactInfoOnAzure[];
}

const ResponseTeamList = ({ users }: ResponseTeamListProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ height: '90%', overflowY: 'auto', padding: 0 }}>
      {users?.length > 0 ? (
        <Table>
          <TableBody>
            {users.map((item) => (
              <TableRow key={item.auth_id}>
                <TableCell
                  sx={{
                    borderBottom: 'none',
                    paddingY: 1.5,
                    paddingX: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: 15,
                      fontWeight: 400,
                      lineHeight: 1.2,
                    }}
                  >
                    {item.first_name ?? ''} {item.last_name ?? ''}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: 13,
                      color: COLORS.GREY,
                      marginTop: 0.3,
                    }}
                  >
                    {item.phone_number ?? ''}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Typography sx={{ color: COLORS.WHITE }}>
          {t(StringKeys.THIS_USER_HAS_NO_EMERGENCY_RESPONSE_TEAM_MEMBERS)}
        </Typography>
      )}
    </Box>
  );
};

export default ResponseTeamList;
